module.exports = __webpack_public_path__ + "static/media/cases_3d_keslon_04a.044f31a6.jpg";